import styled from 'styled-components';
import { Drawer } from 'antd';
import { Typography } from '~/ui/components';
import { themeToggleValue } from '~/common/utils/theme';

export const DrawerModal = styled(Drawer)`
  position: absolute;

  .ant-drawer-mask {
    background-color: ${({ theme }) => themeToggleValue(theme, 'rgba(0, 0, 0, 0.35)', { dark: 'rgba(0, 0, 0, 0.80)' })};
    border-radius: 15px;
  }

  .ant-drawer-content-wrapper {
    border-radius: 16px;
    overflow: hidden;
  }

  .ant-drawer-header {
    text-align: center;
    padding: 24px 24px 16px;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }

  .ant-drawer-content {
    height: auto;
  }

  .ant-drawer-body {
    gap: 8px;
    display: flex;
    flex-direction: column;
  }
`;

export const DrawerText = styled(Typography).attrs(({ theme }) => ({
  type: 'paragraphSmall',
  element: 'h3',
  color: theme.colors.element.secondary,
}))`
  text-align: center;

  b {
    color: ${({ theme }) => theme.colors.element.primary};
  }
`;
